import { getPermissions } from "../../api/permission";

const permission = {
    namespaced: true,
    state: {
        permissions: [],
    },
    getters: {
        groupedPermissions(state) {
            return state.permissions.reduce(function (r, a) {
                r[a.entity] = r[a.entity] || [];
                r[a.entity].push(a);

                return r;
            }, Object.create(null));
        },
    },
    mutations: {
        SET_PERMISSIONS: (state, payload) => {
            state.permissions = payload;
        },
    },
    actions: {
        async getPermissions({ commit }) {
            const { data } = await getPermissions();
            commit("SET_PERMISSIONS", data);
        },
    },
};

export default permission;
